const dappUrlGenerator = (slug: string) => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'development':
      return `https://staging.mint.cakeapp.xyz/${slug}`;
    case 'production':
      return `https://mint.cakeapp.xyz/${slug}`;
    default:
      return `https://mint.cakeapp.xyz/${slug}`;
  }
};

export default dappUrlGenerator;
